import './dishcatering/style';
import FormStructure from './dishcatering/form_structure';

export default FormStructure;